export class ItemSat {
    public ITEM_SAT_ID: number;
    public NAME_SAT: string;
    public DESCRIPTION: string;
    public TYPE: string;
    public loacs?: string;
    }


// WEBPACK FOOTER //
// ./src/app/models/item-sat.ts